import React from 'react';
import { Tooltip } from '@saucelabs/ds-tooltip';
import { IconInformationFill } from '@saucelabs/ds-icons';

const SwitchInfoTooltip: React.FC<{title: string}> = ({ title }) => (
  <Tooltip
    placement="top"
    title={(
      <div className="max-w-39.75">
        {title}
      </div>
    )}
  >
    <span className="ml-1 text-gray-500">
      <IconInformationFill className="w-2 h-2 fill-current" />
    </span>
  </Tooltip>
);

export default SwitchInfoTooltip;
